import { BRAND } from "@/lib/brand";

/**
 * BrandMark — logo + name side by side.
 * variant: "sidebar" (small) | "topbar" (breadcrumb size) | "login" (large) | "compact"
 */
export function BrandMark({ variant = "sidebar", showTagline = false, className = "" }) {
  const size = {
    sidebar: { img: 36, title: "text-base", sub: "text-[10px]" },
    topbar: { img: 22, title: "text-sm", sub: "text-[9px]" },
    login: { img: 44, title: "text-xl", sub: "text-[10px]" },
    compact: { img: 28, title: "text-sm", sub: "text-[9px]" },
    hero: { img: 56, title: "text-2xl", sub: "text-[11px]" },
  }[variant];

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid={`brand-mark-${variant}`}>
      <img
        src={BRAND.logoUrl}
        alt={BRAND.name}
        width={size.img}
        height={size.img}
        style={{ height: size.img, width: "auto", objectFit: "contain" }}
        className="rounded-md bg-white/90 dark:bg-white/95 p-1 shadow-sm ring-1 ring-black/5"
      />
      <div className="min-w-0">
        <div className={`font-display font-semibold tracking-tight leading-none ${size.title}`}>
          {BRAND.name}
        </div>
        {showTagline && (
          <div className={`uppercase tracking-[0.25em] text-muted-foreground mt-1 ${size.sub}`}>
            {BRAND.tagline}
          </div>
        )}
      </div>
    </div>
  );
}

export default BrandMark;
